<template>
  <section
    id="apply"
    class="bg-[#dff0d8] py-20"
  >
    <div class="co-container-sm mx-auto bg-co-gray-50 px-4 py-[3.25rem] shadow md:px-[3.25rem]">
      <div
        v-if="subTitle"
        class="mb-2 text-center"
      >
        <span class="border-b border-co-primary-400 px-1 text-co-primary-400">
          {{ subTitle }}
        </span>
      </div>
      <h2 class="co-display-7 mb-4 text-center">
        {{ courseTitle }}
        <br>
        お申し込み
      </h2>
      <div>
        <p class="mb-[3.25rem] text-center">
          <span class="inline md:block">
            <a
              href="/terms"
              target="_blank"
            >
              利用規約
            </a>に同意の上、下記フォームに内容を記入してお申し込みください。
          </span>
          <span class="inline md:block">
            お申し込み後、メールにて入金のご案内をお送り致します。
          </span>
        </p>
      </div>

      <TeCommonApplyTimeLimit :latest-cohort="latestCohort" />

      <TeCourseApplyForm
        :course="course"
        :cohorts="cohorts"
        :latest-cohort="latestCohort"
        :sakiwari-cohorts="sakiwariCohorts"
        :current-promotion="currentPromotion"
        :course-name-path="courseNamePath"
        :entry-discount-time-limit="entryDiscountTimeLimit"
        :plan-twelve-week-lite="planTwelveWeekLite"
        :entry-campaign="entryCampaign"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'

import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonApplyTimeLimit from '~/components/Te/TeCommon/TeCommonApplyTimeLimit/TeCommonApplyTimeLimit.vue'
import TeCourseApplyForm from '~/components/Te/TeCourse/TeCourseApplyForm.vue'

const options = {
  props: {
    cohorts: {
      type: Array,
      default: () => [],
    },
    latestCohort: {
      default: null,
    },
    sakiwariCohorts: {
      type: Array,
      default: () => [],
    },
    course: {
      default: null,
    },
    currentPromotion: {
      type: Object,
    },
    courseNamePath: {
      type: String,
    },
    entryDiscountTimeLimit: {
      default: null,
    },
    planTwelveWeekLite: {
      default: false,
    },
    entryCampaign: {
      type: Object,
      default: null,
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
  filters: {},
  computed: {
    courseTitle() {
      return this.course ? this.course.attributes.title : '-'
    },
  },
  components: {
    TeCommonBannerTimeLimitCpnCode,
    TeCommonApplyTimeLimit,
    TeCourseApplyForm,
  },
}

export default defineNuxtComponent(options)
</script>
